import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-bar-images',
  templateUrl: './progress-bar-images.component.html',
  styleUrls: ['./progress-bar-images.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarImagesComponent implements OnInit {
  @Input()
  public currentIndex$;
  @Input()
  public stepOrder: any[];
  @Input()
  public isCompleted: boolean;

  // Progress bar translation in element width %
  public translateAmount: number;
  // % amount between each image
  public imageInterval: number;

  constructor() {}

  ngOnInit(): void {
    this.currentIndex$.subscribe((value) => {
      // We want to translate -100% to left and add the current percentage
      if (this.isCompleted) {
        this.translateAmount = 0;
      } else {
        this.translateAmount = -100 + this.calculatePercentage(this.stepOrder.length + 1, value + 1);
      }
    });

    this.imageInterval = this.calculatePercentage(this.stepOrder.length + 1, 1);
  }

  // Calculates the progression in percentages from given index related to array length
  calculatePercentage(arrayLength: number, index: number): number {
    return Math.abs((index / arrayLength) * 100);
  }
}
